<template>
    <v-container>
        <v-container style="display: flex; justify-content: space-between;">
            <h2>Movimentação de Estoque</h2>
        </v-container>
        <v-container class="d-flex justify-space-between pt-2 align-center" :class="themeClass">
          <v-text-field
            v-model="searchText"
            label="Pesquisa"
            prepend-icon="mdi-magnify"
            dense
            style="width: 100%;"
            class="ml-2 mr-2 align-end"
          ></v-text-field>
          <v-btn @click="setIsOpenModal" style="box-shadow: none; height: 30px; margin: 0px 8px; background-color: blue; color: white !important;" small>
            Adicionar <v-icon style="margin-left: 4px;">mdi-plus</v-icon>
          </v-btn>
        </v-container>
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            disable-sort
            :single-expand="false"
        >
        </v-data-table>

        <CreateMovimentacaoDeEstoque :value="isModalOpen" @close="isModalOpen=false" :codigo="codeAutoInc" :refreshMovimentacaoDeEstoque="getMovimentacaoDeEstoque" />
    </v-container>
  </template>
  
  <script>
  import Vue from 'vue';
  import CreateMovimentacaoDeEstoque from "./MovimentacaoDeEstoqueCreateView.vue"
  import { width } from 'cli-color/window-size';
  import jsPDF from "jspdf";

  export default {
    components: {
      CreateMovimentacaoDeEstoque
    },
    data() {
      return {
        isEditModalOpen: false,
        userEmail: '',
        itemToDelete: null, 
        activeTab: 0,
        isModalOpen: false,
        searchText: '',
        osCodigo: '',
        codeAutoInc: '',
        itemsPerPage: 50, // Limite inicial de itens por página
        currentPage: 1, // Página inicial
        filterDialog: false, // Controle do modal de filtros
        filters: {
          item: { value: '', label: 'Item', items: this.filterItem, type: 'combobox' }
        },
        tab: null,
        headers: [
          { text: "Código", value: "codigo", width: '100px' },
          { text: "Item", value: "itemDescricao", width: '180px' },
          { text: "Tipo de Operação", value: "tipoOperacaoDescricao", width: '100px' },
          { text: "Quantidade", value: "quantidade", width: '100px' },
          { text: "Origem", value: "origemDescricao", width: '180px' },
          { text: "Destino", value: "destinoDescricao", width: '180px' },
        ],
        items: [],
        customItemsPerPageOptions: [
            { title: '50', value: 50 },
            { title: '100', value: 100 },
            { title: '150', value: 150 },
            { title: '200', value: 200 }
        ], // Opções de limite
      };
    },
    computed: {
      themeClass() {
        return this.$vuetify.theme.dark ? 'dark-theme' : 'light-theme';
      },
    },
    methods: { 

      async getTenanty(){
        const lc = window.localStorage.getItem("user-login");
        const user = JSON.parse(lc);
        this.userEmail = user[1];
      },

      async getBase64FromUrl(url) {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
          }
        });
      },

      clearFilter(key) {
        if (this.filters[key]) {
          this.filters[key].value = null; // Reseta apenas o valor do filtro
        }
      },

      setIsOpenFilterDialog() {
        this.filterDialog = !this.filterDialog;
      },

      // Abre o modal de filtros
      async setIsOpenModal() {
        let req = await Vue.prototype.$http.get(`/Entity/AutoInc`, { params: { schemaName: "StockMov", field: "codigo", mask: "#########"}});
        this.codeAutoInc = req.data;
        this.isModalOpen = !this.isModalOpen;
      },

      async getMovimentacaoDeEstoque() {

        let searchFields = [];
        let values = [];

        // Converta os arrays para strings separadas por vírgulas
        searchFields = searchFields.join(',');
        values = values.join(',');

        // Faça a requisição com os parâmetros ajustados
        let req = await Vue.prototype.$http.get(`/Entity/StockMov/search-fields?value=[${this.searchText}],[${this.searchText}],[${this.searchText}],[${this.searchText}],[${this.searchText}]&searchFields=[codigo,itemDescricao,origemDescricao,destinoDescricao,tipoOperacaoDescricao]&limit=${this.itemsPerPage}&page=${this.currentPage}`)

        this.items = req.data.data.data;

      },
    },
    watch: {
      searchText: {
        handler(val) {
          clearTimeout(this._searchDebounce);
          this._searchDebounce = setTimeout(() => {
            this.getMovimentacaoDeEstoque();
          }, 500);
        },
        immediate: false
      }
    },
    created() {
      this.getMovimentacaoDeEstoque();
      this.getTenanty();
    }
  };
  </script>
  <style scoped>
  
    .v-data-table thead th,
    .v-data-table tbody td {
      text-overflow: ellipsis; /* Trunca textos longos */
      white-space: nowrap;
      overflow: hidden;
    }
  
    ::-webkit-scrollbar {
      height: 5px !important;
    }
  
    ::-webkit-scrollbar-thumb {
      background-color: #230BC1 !important;
    }
  
    .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > th {
      height: 48px;
      border-bottom: 0;
    }
  
    .v-application--is-ltr .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
      text-align: center !important;
      border-bottom: 0 !important;
    }
  
    .statusTd {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      height: 53px !important;
    }
  
    .activeCircle {
      border: 1px solid rgb(197, 167, 34);
      border-radius: 100%; 
      height: 0.5rem; 
      width: 0.5rem; 
      opacity: 80%; 
      background-color: rgb(34 197 94);
    }
  
    .inactiveCircle {
      border: 1px solid rgb(197, 167, 34);
      border-radius: 100%; 
      height: 0.5rem; 
      width: 0.5rem; 
      opacity: 80%; 
      background-color: #F00;
    }
  
    .v-application .elevation-1 {
      box-shadow: none !important;
    }
  
    .mdi-arrow-up::before {
      font-size: 15px !important;
    }
  
    .mdi-arrow-up::after {
      font-size: 15px !important;
    }
  
    .actionIcon {
      font-size: 18px !important;
    }
  
    .v-text-field--outlined fieldset {
      border: 0;
      border-bottom: 1px solid black;
      border-radius: 0;;
    }
  
    .v-text-field--outlined .v-text-field__slot {
      align-items: end !important;
    }
  
    .v-text-field .v-input__slot {
      padding: 0 !important;
    }
  
    .filterInput {
      outline: none;
      border: 1px solid #e1e1e1;
      color: #000;
      border-radius: 4px;
      margin-right: 18px;
      width: 269px;
      padding-left: 10px;
      font-size: 12px;
      height: 40px;
    }
  
    .theme--dark > .filterInput {
      outline: none;
      border: 1px solid #e1e1e1;
      color: #FFF !important;
      border-radius: 4px;
      margin-right: 18px;
      width: 269px;
      padding-left: 10px;
      font-size: 12px;
      height: 40px;
    }
  
    .filterInputDate {
      outline: none;
      border: 1px solid #666;
      border-radius: 4px;
      margin-right: 18px;
      width: 269px;
      padding-left: 10px;
      font-size: 12px;
      height: 40px;
    }
  
    input[type="date"]::-webkit-calendar-picker-indicator {
      cursor: pointer;
      border-radius: 4px;
      margin-right: 2px;
      opacity: 0.6;
      filter: invert(0.8);
    }
  
    .container {
      margin-right: 0;
      margin-left: 0;
      max-width: 100%;
    }
    
    .theme--dark > .dialogTitle {
      color: #000;
    }
  
     .dark-theme {
      background-color: #1E1E1E;
    }
  
    .v-slide-group__prev, .v-slide-group__prev--disabled {
      display: none !important;
    }
  
    .v-slide-group__next--disabled, .v-slide-group__prev--disabled {
      display: none !important;
    }
  
    .dark-theme {
      color: white;
    }
  
    .light-theme {
      color: #666;
    }

    .addButton {
      display: flex;
      gap: "12px"
    }

    ::v-deep(.v-data-table td) {
      overflow: hidden !important;
    }

    ::v-deep(.v-text-field__details) {
      display: none !important;
    }
  </style>